<ng-container *ngIf="!isLoading">
    <ng-container *ngIf="displayMode == DisplayMode.Modal && areProjectDataReady">
        <div *ngIf="this.insightsSummaryStatus === null || this.insightsSummaryStatus !== AiReportSummaryStatus.COMPLETED">
            <app-titan-button [variant]="'primaryOldVersion'" [isDisabled]="this.insightsSummaryStatus !== null"
                (onPress)="this.startInsightsSummaryGeneration()">
                <ng-container *ngIf="this.insightsSummaryStatus === null" children>
                    <span>Generate Insights Summary</span>
                </ng-container>
                <ng-container *ngIf="this.insightsSummaryStatus !== null" children>
                    <span>Generating Insights Summary...</span>
                </ng-container>
            </app-titan-button>
        </div>

        <div *ngIf="this.insightsSummaryStatus === AiReportSummaryStatus.COMPLETED">
            <app-titan-button [variant]="'primaryOldVersion'" (onPress)="showInsightsSummaryDialog()" [isDisabled]="!this.insightsSummaryContent">
                <ng-container *ngIf="this.insightsSummaryContent" children>
                    <span>View Insights Summary</span>
                </ng-container>
                <ng-container *ngIf="!this.insightsSummaryContent" children>
                    <span>Getting Insights Summary...</span>
                </ng-container>
            </app-titan-button>
        </div>
    </ng-container>


    <ng-container *ngIf="displayMode == DisplayMode.TextOnly">
        <div *ngIf="!areProjectDataReady">
            <app-embedded-message
                [title]="errorTitle"
                [textContent]="errorMessage"
                [type]="'error'"
                [actionText]="errorActionText">
            </app-embedded-message>
        </div>

        <div *ngIf="areProjectDataReady">
            <div *ngIf="this.insightsSummaryStatus === AiReportSummaryStatus.COMPLETED" class="ai-report-summary-dialog">
                <h5>{{ "Insights Summary - " + project?.name }}</h5>
                <div [innerHTML]="parsedInsightsSummaryWithoutTitle"></div>
            </div>

            <div *ngIf="this.insightsSummaryStatus !== AiReportSummaryStatus.COMPLETED">
                <app-embedded-loader
                    [title]="loaderDialogTitle"
                    [textContent]="loaderDialogContent"
                    [image]="loaderDialogImage"
                    [countdown]="loaderDialogCountdown"
                    [countdownText]="loaderDialogCountdownText"
                    >
                </app-embedded-loader>
            </div>
        </div>
    </ng-container>
</ng-container>